module.exports = __webpack_public_path__ + "static/media/car-qr-code.1086837d.svg";